module.exports = __webpack_public_path__ + "static/media/bashir.d7d2535d.jpg";